export const showError = (text) => {
    console.log(text)
    let message = 'Network Errors'
    if (typeof text === 'string')
        message = text
    return (dispatch) => {
        dispatch(errorMessage(message, true))

        window.setTimeout(() => {
            dispatch(errorMessage('', false))
        }, 4000)
    }
}

const errorMessage = (text, open) => {
    return {
        type: 'ERROR_ACTION',
        text,
        open
    }
}